const storage = window.sessionStorage

export const get = item => JSON.parse(storage.getItem(item))

export const set = (item, value) => storage.setItem(item, JSON.stringify(value))

export const remove = (item) => storage.removeItem(item)

export default {
  get,
  set,
  remove
}



// WEBPACK FOOTER //
// ./src/helpers/sessionStorage.js